// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "f7ab7edf8b13";
export const BUILD_VERSION_NUMBER = 82;
